import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Check = () => (
  <FontAwesomeIcon
    style={{
      position: "absolute",
      color: "rgb(30, 182, 132)",
      opacity: "0.8",
      top: "25%",
      left: "15%",
      margin: "auto",
      fontSize: "6rem",
    }}
    icon={faCheckCircle}
  />
)

export default Check
